import { useStateStore } from '$tablet-app/src/app/stores/useStateStore';
import { LockScreenMode } from '../stores/types';
import LockScreenView from './LockScreenView';
import { getLockScreenTitle } from './LockScreenView/getLockScreenTitle';

export const LockScreen = () => {
  const {
    error,
    forgot_pin,
    input,
    mode,
    checking,
    confirm_reset_pin,
    prompt_reset_pin,
    inputNumber,
    close,
    removeNumber,
    openForgotPinDialog,
  } = useStateStore((state) => state.lock_screen);

  return (
    <LockScreenView
      title={getLockScreenTitle({
        error,
        forgot_pin,
        checking,
        confirm_reset_pin,
        prompt_reset_pin,
      })}
      input={input}
      error={error}
      forgot_pin={forgot_pin}
      onInputNumber={inputNumber}
      onRemoveNumber={removeNumber}
      onPressForgot={openForgotPinDialog}
      onClose={mode === LockScreenMode.PROFILE_SWITCH ? close : undefined}
    />
  );
};
